import ThaiAddress from './components/ThaiAddress';
export default ThaiAddress;


// WEBPACK FOOTER //
// ./src/lib/index.js